<template>
	<div class="scene">
		<div class="fixation">
			<div class="category">
				<div class="line">
					<div class="key">
						标的物类型
					</div>
					<ul class="typeCategory">
						<li :class="typeValue == item.id ? 'current':''" v-for="(item,index) in type" :key="index"
							@click="useType(index,item.id)">
							{{item.name}}
						</li>
					</ul>
					<ul class="typeCategory" v-if="typeValue != ''">
						<li :class="categoryValue == item.id ? 'current':''" v-for="(item,index) in category"
							:key="index" @click="useCategory(item.id)">
							{{item.name}}
						</li>
					</ul>
				</div>
				<div class="line">
					<div class="key">
						拍卖状态
					</div>
					<ul class="typeCategory">
						<li :class="statusIndex == index ? 'current':''" v-for="(item,index) in status" :key="index"
							@click="useStatus(index)">
							{{item.name}}
						</li>
					</ul>
				</div>
				<div class="line" id="flex-start">
					<div class="key">
						开拍时间
					</div>
					<ul>
						<li :class="timeIndex == index ? 'current':''" v-for="(item,index) in time" :key="index"
							@click="useDateScope(index)">
							{{item.name}}
						</li>
					</ul>
					<div class="date">
						<el-date-picker v-model="dateScope" type="daterange" range-separator="至" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"
							@change="dateChange">
						</el-date-picker>
					</div>
				</div>
			</div>
			<div class="commodity-block" v-if="list.length > 0">
				<commodity v-for="(item,index) in list" :key="index" :node="item"></commodity>
			</div>
			<div class="commodity-block" v-else>
				<div class="empty">
					<el-empty></el-empty>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'scene',
		data() {
			return {
				type: [],
				typeIndex: 0,
				typeValue: '',
				category: [],
				categoryValue: '',
				status: [{
						id: 0,
						name: '不限'
					},
					{
						id: 1,
						name: '即将开始'
					},
					{
						id: 2,
						name: '正在进行'
					},
					{
						id: 3,
						name: '已结束'
					},
					// {
					// 	id: 4,
					// 	name: '撤回'
					// },
					// {
					// 	id: 5,
					// 	name: '终止'
					// }
				],
				statusIndex: 0,
				time: [{
						id: 0,
						name: '不限'
					},
					{
						id: 1,
						name: '近三天'
					},
					{
						id: 6,
						name: '近七天'
					},
					{
						id: 11,
						name: '近一月'
					}
				],
				timeIndex: 0,
				dateScope: ['', ''],
				list: [],
				currentPage: 1
			};
		},
		watch: {
			$route(to, from) {
				let path = to.path
				this.disposeRouter(path)
			},
			auctionKeyword(keyword) {
				this.keyword = keyword
				this.list = []
				this.fetchList()
			}
		},
		computed: {
			auctionKeyword() {
				return this.$store.state.auctionKeyword
			}
		},
		methods: {
			dateChange() {
				this.timeIndex = ''
				this.fetchList()
			},
			useDateScope(index) {
				this.timeIndex = index
				if (index > 0) {
					let time = this.$pub.getDetailTime()
					let today = time.year + '-' + time.month + '-' + time.day
					let add = 0
					switch (index) {
						case 1:
							add = 2
							break;
						case 2:
							add = 6
							break;
						default:
							add = 29
							break;
					}
					let target = this.$pub.dateChange(add, today)
					this.dateScope = [today, target]
				} else {
					this.dateScope = ['', '']
				}
				this.fetchList()
			},
			disposeRouter(path) {
				if (path == '/advance') {
					this.statusIndex = 1
				} else if (path == '/scene') {
					this.statusIndex = 2
				} else{
					this.statusIndex = 0
				}
				if (this.$store.state.auctionKeyword) {
					this.keyword = this.$store.state.auctionKeyword
				} else {
					this.keyword = ''
				}
				this.typeValue = ''
				this.typeIndex = 0
				this.categoryValue = ''
				this.category = []
				this.dateScope = ['', '']
				this.timeIndex = 0
				this.list = []
				this.fetchList()
			},
			fetchCategory() {
				this.$api.frontCategory({}, res => {
					if (res.code == 200) {
						let list = res.data
						list.unshift({
							id: '',
							name: '不限'
						})
						this.type = list
						if (this.typeValue != '') {
							for (let i = 0; i < list.length; i++) {
								if (this.typeValue == list[i]['id']) {
									let array = list[i]['children']
									array.unshift({
										id: '',
										name: '不限'
									})
									this.category = array
									break;
								}
							}
						}
					}
				})
			},
			useType(index, value) {
				if (index != 0) {
					let list = JSON.parse(JSON.stringify(this.type[index]['children']))
					list.unshift({
						id: '',
						name: '不限'
					})
					this.category = list
				} else {
					this.category = []
				}
				this.typeValue = value
				this.currentPage = 1
				this.fetchList()
			},
			useCategory(value) {
				this.categoryValue = value
				this.currentPage = 1
				this.fetchList()
			},
			useStatus(index) {
				this.statusIndex = index
				this.currentPage = 1
				this.fetchList()
			},
			fetchList() {
				this.$api.frontCommodityList({
					pageNum: this.currentPage,
					pageSize: 16,
					lotOneType: this.typeValue,
					lotTwoType: this.categoryValue,
					auctionStatus: this.status[this.statusIndex]['id'] == 0 ? '' : this.status[this.statusIndex][
						'id'
					],
					lotName: this.keyword,
					startDate: this.dateScope[0],
					endDate: this.dateScope[1]
				}, res => {
					if (res.code == 200) {
						let list = res.data.list
						let array = new Array()
						for (let i = 0; i < list.length; i++) {
							let transTime = ''
							if (list[i].auctionStatus == 1) {
								transTime = list[i]['startTime']
							} else {
								transTime = list[i]['endTime']
							}
							let diff = this.$pub.timeStampDifferene(transTime)
							let obj = {
								image: list[i]['lotPictrueUrl'],
								name: list[i]['lotName'],
								now: !list[i]['currentPrice'] ? list[i]['startPrice'] : list[i][
									'currentPrice'
								],
								number: !list[i]['biddingCount'] ? 0 : list[i][
									'biddingCount'
								],
								evaluated: list[i]['evaluationPrice'],
								day: diff.day,
								timeStr: diff.h+':'+diff.m+':'+diff.s,
								view: !list[i]['watchFrequency'] ? 0 : list[i][
									'watchFrequency'
								],
								people: !list[i]['enrollNumber'] ? 0 : list[i][
									'enrollNumber'
								],
								status: parseInt(list[i]['auctionStatus']),
								start: list[i]['startPrice'],
								id: list[i]['id'],
								tag: list[i]['lotLabel'].split(',')
							}
							array.push(obj)
						}
						if (this.currentPage == 1) {
							this.list = array
						} else {
							this.list = this.list.concat(array)
						}
						this.totalPage = Math.ceil(res.data.total / 16)
					}
				})
			},
			pageScroll() {
				if (this.currentPage == this.totalPage) {
					return
				}
				let scrollTop = document.documentElement.scrollTop
				let scrollHeight = document.documentElement.scrollHeight
				let clientHeight = document.documentElement.clientHeight
				if (scrollTop + clientHeight - scrollHeight >= 0) {
					console.log("页面到底");
					this.currentPage++;
					//滚动至底部后请求数据
					this.fetchList();
				}
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.path = this.$route.path
			this.typeValue = this.$store.state.firstId
			this.categoryValue = this.$store.state.secondId
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchCategory()
			this.disposeRouter(this.path)
			window.onscroll = this.pageScroll
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.scene {
		width: 100%;
		background: @vue-bg-color-grey;
		padding-top: @vue-spacing-col-lg;
		box-sizing: border-box;
	}

	.category {
		width: 100%;
		background: @vue-bg-color;
		box-shadow: 0px 0px 10px @vue-border-color;
		padding: @vue-spacing-col-base @vue-spacing-row-base;
		box-sizing: border-box;

		.line {
			width: 100%;
			border-bottom: 1px dashed @vue-border-color;
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-end;

			.key,
			ul,
			.date {
				height: 60px;
				display: flex;
				align-items: center;
			}

			.key {
				width: 120px;
				color: @vue-text-color-grey;
			}

			.typeCategory {
				width: calc(100% - 120px);
			}

			ul {
				li {
					padding: 7px 12px;
					box-sizing: border-box;
					font-size: @vue-font-size-sm - 2;
					margin-right: @vue-spacing-row-base;
					cursor: pointer;
				}

				li:hover {
					background: #fbebea;
					color: #d71419;
					border-radius: 16px;
				}

				.current {
					background: #fbebea;
					color: #d71419;
					border-radius: 16px;
				}
			}
		}

		#flex-start {
			justify-content: flex-start;
		}
	}

	.commodity-block {
		margin-top: @vue-spacing-col-lg;

		.empty {
			width: 100%;
			height: 400px;
			background: @vue-bg-color;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-bottom: @vue-spacing-col-lg;
		}
	}
</style>
